import registerSidebarComponents from './sidebar';
import registerCalculatorComponents from './calculator';
import registerCarouselComponents from './carousel';
import registerChangeKeyboardLanguage from './changeKeyboardLanguage';
import registerChangeLanguage from './changeLanguage';
import registerCharts from './charts';
import registerCore from './core';
import registerNavbar from './navbar';
import registerGrid from './grid';
import registerStatusmap from './statusmap';
import registerTab from './tab';
import registerSheetHeadlineDirective from './sheet/SheetHeadlineDirective';
import registerQuestionHeadlineDirective from './question/QuestionHeadlineDirective';
import registerTwocolumnsDirective from './twocolumns/TwoColumnsDirective';
import registerIbmediaDirective from './media/MediaDirective';
import registerColorThemeDirective from './colorTheme/ColorThemeDirective';
import registerModalDirective from './modal/ModalDirective';
import registerCMSComponents from './cms';
import registerSheetLeaveComponent from './sheetLeaveComponent';
import registerPreloadIndicatorComponent from './preloadIndicator';
import registerHighlighterDirective from './texthighlighter/TextHighlighterDirective';
import registerExpandableContainerComponent from './ExpandableContainer';
//REMOVED: Now using the vanilla video player fullscreen feature: import registerMediaFullScreenDirective from './media/MediaFullscreenDirective';

export default function registerComponents(angular) {
    //REMOVED: Now using the vanilla video player fullscreen feature: registerMediaFullScreenDirective(angular);   
    registerSidebarComponents(angular);
    registerCalculatorComponents(angular);
    registerCarouselComponents(angular);
    registerChangeKeyboardLanguage(angular);
    registerChangeLanguage(angular);
    registerCharts(angular);
    registerCore(angular);
    registerNavbar(angular);
    registerGrid(angular);
    registerStatusmap(angular);
    registerSheetHeadlineDirective(angular);
    registerQuestionHeadlineDirective(angular);
    registerTwocolumnsDirective(angular);
    registerTab(angular);
    registerIbmediaDirective(angular);
    registerColorThemeDirective(angular);
    registerModalDirective(angular);
    registerCMSComponents(angular);
    registerSheetLeaveComponent(angular);
    registerPreloadIndicatorComponent(angular);
    registerHighlighterDirective(angular.module('assessmentFrontendDirectives'));
    registerExpandableContainerComponent(angular);
}